import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { HistoryOutlined , SwapOutlined,  CheckCircleOutlined, LineChartOutlined,RiseOutlined ,ItalicOutlined } from '@vicons/antd';
import { PricetagOutline} from '@vicons/ionicons5';
  
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.prefix 菜单名称前缀, 用于确定唯一名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/projectBudget',
    name: 'projectbudget',
    redirect: 'projectBudget/currentBudget',
    component: Layout,
    meta: {
      title: 'Project Budget',
      icon: renderIcon(RiseOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      //permissions: ['projectbudget_currentBudget_read', 'projectbudget_approvedBudget_read'],
      sort: 3,
    },
    children: [
      {
        path: 'createBudget',
        name: 'projectbudget_createbudget',
        meta: {
          title: '1553 Template',
          prefix: '',
          icon: renderIcon(RiseOutlined),
          spname:"created_budget",
          //配置该路由需要哪些权限可访问 这里是针对单个路由
         // permissions: ['projectbudget_currentbudget_read'],
        },
        component: () => import('@/views/createBudget/index.vue'),
      },
/*
      {
        path: 'createdBudgetTransfer',
        name: 'projectbudget_TransferBudget',
        meta: {
          title: 'Transfer',
          prefix: '',
          icon: renderIcon(BusinessOutline),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['projectbudget_currentBudget_read','system_list_1553_line_read'],
        },
        component: () => import('@/views/createBudget/createdBudgetTransfer.vue'),
      },

   */
      {
        path: 'currentbudget',
        name: 'currentbudget',
        meta: {
          title: 'Budget',
          prefix: '',
          spname:"current_budget",
          icon: renderIcon(LineChartOutlined ),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['currentbudget_read'],
        },
        component: () => import('@/views/currentBudget/index.vue'),
       
      },
      {
        path: 'currentbudgetwithtax',
        name: 'currentbudgetwithtax',
        meta: {
          title: 'Current Budget with Tax',
          prefix: '',
          icon: renderIcon(LineChartOutlined ),
          hidden:true,
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['currentbudget_read'],
        },
        component: () => import('@/views/currentBudget/currentBudgetWithTax.vue'),
       
      },
      {
        path: 'budgetTransfer',
        name: 'projectbudget_budgettransfer',
        meta: {
          title: 'Budget Transfer',
          prefix: 'currentBudget',
          icon: renderIcon(SwapOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['projectbudget_budgettransfer_read'],
        },
        component: () => import('@/views/currentBudget/budgetTransfer.vue'),
        //component: () => import('@/views/comingsoon/view/index.vue'),
       
      },
      {
        path: 'budgetHistory',
        name: 'projectbudget_budgethistory',
        meta: {
          title: 'Budget Version',
          spname: 'budget_history',
          prefix: '',
          icon: renderIcon(HistoryOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['projectbudget_budgethistory_read'],
        },
        //component: () => import('@/views/comingsoon/view/index.vue'),
        component: () => import('@/views/currentBudget/budgetHistory.vue'),
       
      },
      {
        path: 'commitment',
        name: 'projectbudget_commitment',
        meta: {
          title: 'Commitment',
          prefix: '',
          icon: renderIcon(CheckCircleOutlined),
          hidden:false,
          spname:"commitment_all",
          historyTable:"commitment",
          // form fields use 'vw_commitment' binding
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['projectbudget_commitment_read'],
        },
        component: () => import('@/views/currentBudget/commitment/index.vue'),
        //component: () => import('@/views/comingsoon/view/index.vue'),
      },
      {
        path: 'invoice',
        name: 'projectbudget_invoice',
        meta: {
          title: 'Invoice',
          prefix: '',
          icon: renderIcon(ItalicOutlined),
          hidden:false,
          //spname:"invoice",
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['projectbudget_invoice_read'],
        },
        component: () => import('@/views/currentBudget/invoice/invoice.vue'),
        //component: () => import('@/views/comingsoon/view/index.vue'),
      },

      
     

   
      {
        path: 'review',
        name: 'createdbudget_review',
        meta: {
          title: 'Review',
          prefix: 'createdBudget',
          icon: renderIcon(PricetagOutline),
          hidden:true,
          //配置该路由需要哪些权限可访问 这里是针对单个路由
         // permissions: ['projectbudget_approvedBudget_read'],
        },
      
        component: () => import('@/views/createBudget/review/index.vue'),
      },
      {
        path: 'form1553',
        name: 'createdbudget_1553',
        meta: {
          title: '1553',
          prefix: 'createdBudget',
          icon: renderIcon(PricetagOutline),
          hidden:true,
          spname:"created_budget",
          
          //配置该路由需要哪些权限可访问 这里是针对单个路由
         // permissions: ['projectbudget_approvedBudget_read'],
        },
        component: () => import('@/views/currentBudget/form1553/index.vue'),
      },

      //create budget line route
 {
  path: 'createBudgetLine5',
  name: 'createBudgetline5',
  meta: {
    title: 'Line 05',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/constructionCost/line5Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine6',
  name: 'createBudgetline6',
  meta: {
    title: 'Line 06',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/constructionCost/line6Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine7',
  name: 'createBudgetline7',
  meta: {
    title: 'Line 07',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/constructionCost/line7Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},

{
  path: 'createBudgetLine9',
  name: 'createBudgetline9',
  meta: {
    title: 'Line 09',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/constructionCost/line9Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine10',
  name: 'createBudgetline10',
  meta: {
    title: 'Line 10',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line10Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine11',
  name: 'createBudgetline11',
  meta: {
    title: 'Line 11',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line11Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},

{
  path: 'createBudgetLine12',
  name: 'createBudgetline12',
  meta: {
    title: 'Line 12',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line12Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine13',
  name: 'createBudgetline13',
  meta: {
    title: 'Line 13',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line13Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine14',
  name: 'createBudgetline14',
  meta: {
    title: 'Line 14',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line14Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine15',
  name: 'createBudgetline15',
  meta: {
    title: 'Line 15',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line15Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine16',
  name: 'createBudgetline16',
  meta: {
    title: 'Line 16',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line16Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine17',
  name: 'createBudgetline17',
  meta: {
    title: 'Line 17',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line17Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine18',
  name: 'createBudgetline18',
  meta: {
    title: 'Line 18',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line18Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine19',
  name: 'createBudgetline19',
  meta: {
    title: 'Line 19',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line19Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine20',
  name: 'createBudgetline20',
  meta: {
    title: 'Line 20',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line20Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},
{
  path: 'createBudgetLine21',
  name: 'createBudgetline21',
  meta: {
    title: 'Line 21',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/consultantCost/line21Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},

{
  path: 'createBudgetLine27',
  name: 'createBudgetline27',
  meta: {
    title: 'Line 27',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/otherCost/line27Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},

{
  path: 'createBudgetLine25',
  name: 'createBudgetline25',
  meta: {
    title: 'Line 25',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/otherCost/line25Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},

{
  path: 'createBudgetLine24',
  name: 'createBudgetline24',
  meta: {
    title: 'Line 24',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/otherCost/line24Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},


{
  path: 'createBudgetLine28',
  name: 'createBudgetline28',
  meta: {
    title: 'Line 28',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/otherCost/line28Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},

{
  path: 'createBudgetLine29',
  name: 'createBudgetline29',
  meta: {
    title: 'Line 29',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/otherCost/line29Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},

{
  path: 'createBudgetLine30',
  name: 'createBudgetline30',
  meta: {
    title: 'Line 30',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/otherCost/line30Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},

{
  path: 'createBudgetLine32',
  name: 'createBudgetline32',
  meta: {
    title: 'Line 32',
    prefix: 'Created Budget',
    icon: renderIcon(PricetagOutline),
    hidden:true,
    //spname:"project_1553_line_budget_item",
    historyTable:"created_budget",
    //配置该路由需要哪些权限可访问 这里是针对单个路由
   // permissions: ['projectbudget_approvedBudget_read'],
  },
  
  component: () => import('@/views/createBudget/equipmentandFurnishings/line32Table.vue'),
  //component: () => import('@/views/comingsoon/view/index.vue'),
},

 //end 
     
      

    ],
  },

 

];

export default routes;
